import React,{ useState, useEffect } from 'react'
import { db } from "../../config/firebase"


const IndividData = ({school, grade}) => {

   const collectionName = school + `${grade}`


   const [a, setA] = useState({})
   const [b, setB] = useState({})
   const [c, setC] = useState({})
   const [d, setD] = useState({})

   useEffect(() => {
      db.collection(collectionName).get()
         .then((querySnapshot) => {
            setA(querySnapshot.docs[0].data())
            setB(querySnapshot.docs[1].data())
            setC(querySnapshot.docs[2].data())
            setD(querySnapshot.docs[3].data())
         })
         .catch(err => console.log(err))
   }, [collectionName])

   return (
      <>

      
         <div  className="course-wrap course-a" school={school} grade={grade} >
            <table>
               <thead>
                  <tr><th colSpan="2">A クラス授業</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>教科</td>
                     <td>月謝</td>
                  </tr>
                  <tr>
                     <td>英語コース</td>
                     <td>{a.l1}</td>
                  </tr>
                  <tr>
                     <td>数学コース</td>
                     <td>{a.l2}</td>
                  </tr>
                  <tr>
                     <td>英語・数学コース</td>
                     <td>{a.l3}</td>
                  </tr>
                  <tr>
                     <td>国語コース</td>
                     <td>{a.l4}</td>
                  </tr>
               </tbody>
            </table>

            <p className="desc">               
               授業時間は各９０分となります。月に90分×4回となります。(担当は特進英語は石田　専科英語は小原と特進数学は山下、専科数学は工藤で予定しています。）<br/>
               都立専科コース：一番最近のテストで７０点以上か通信簿で４の生徒が対象・（都立昭和・東大和南・武蔵野北など難関都立を目指すコースです。）<br/>
               特進科コース：一番最近のテストで８５点以上か通信簿で５の生徒が対象（独自校（地域一番校並びに難関私立・国立を目指すコース）。<br/>
               各コース1,500円の追加オプションで週に1回の演習授業が付けられます。演習授業はビットキャンパスタッチとドリル（演習・定着・確認）、学校教科書対応映像授業（理解・思考）を使います。<br/>
               オプションを追加しなくても家でもどこでもビットキャンパスタッチも映像授業も無償で受講できます。<br/>
               中3都立専科は水曜日(英）・金曜日(数）各7限に設置予定。<br/>
               中3特進科は水曜日６限(英）・金曜日(数）7限に予定しています。各教科別途教材費が2,200円になります。<br/>
               ※クラス授業の振替は原則できませんが寺子屋などで補うことがあります。また自習指導やノートのコピーで補うことが可能です。
            </p>

         </div >


         <div  className="course-wrap course-b">
            <table>
               <thead>
                  <tr><th colSpan="2">B 寺子屋式学習指導</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>授業 / 月</td>
                     <td>月謝</td>
                  </tr>
                  <tr>
                     <td>週1日（各90分 × 4 / 月）</td>
                     <td>{b.l1}</td>
                  </tr>
                  <tr>
                     <td>週2日（各90分 × 8 / 月）</td>
                     <td>{b.l2}</td>
                  </tr>
                  <tr>
                     <td>週3日（各90分 × 12 / 月）</td>
                     <td>{b.l3}</td>
                  </tr>
                  <tr>
                     <td>週4日（各90分 × 16 / 月）</td>
                     <td>{b.l4}</td>
                  </tr>
               </tbody>
            </table>

            <p className="desc">
            講師1人に対して生徒2～4人の授業形態となります。振替授業の関係でまれに5人になる場合があります<br/>
            毎年2人～4人になっています。各曜日各時限において定員は4人以下で設定します。<br/>
            各コース1,５00円の追加で週に1回のH.演習授業が付けられます。<br/>
            H.演習授業はF.ビットキャンパスタッチやドリル、学校教科書対応映像授業を使います。<br/>
            オプション追加をとらなくてもF.ビットキャンパスタッチは受講できます。<br/>
            中学生は教科書対応の映像授業が追加料金なしで受講できます。<br/>
            ※小6受験生は寺子屋では受講できませんのでプレミアムかスタンダードをご検討ください。
            </p>
         </div >


         <div  className="course-wrap course-c">
            <table >
               <thead>
                  <tr><th colSpan="2">C スタンダート個別指導</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>授業 / 月</td>
                     <td>月謝</td>
                  </tr>
                  <tr>
                     <td>週1日（各90分 × 4 / 月）</td>
                     <td>{c.l1}</td>
                  </tr>
                  <tr>
                     <td>週2日（各90分 × 8 / 月）</td>
                     <td>{c.l2}</td>
                  </tr>
                  <tr>
                     <td>週3日（各90分 × 12 / 月）</td>
                     <td>{c.l3}</td>
                  </tr>
                  <tr>
                     <td>週4日（各90分 × 16 / 月）</td>
                     <td>{c.l4}</td>
                  </tr>
               </tbody>
            </table>

            <p className="desc">
               ※小中学生は追加オプションを付けなくても学費に週1回のH.演習授業がついています。<br/>
               H.演習授業に関しては部活や習い事の関係で来れない場合は自宅での学習にすることが可能です。<br/>
               中学生はG.教科書対応の映像授業が追加料金なしで受講できます。<br/>
               小中学生はF.ビットキャンパスタッチは追加料金なしで受講できます。<br/>
               高校生にはE．学びエイド（映像授業）の追加をお勧めします。
            </p>
         </div >


         <div  className="course-wrap course-d">
            <table>
               <thead>
                  <tr><th colSpan="2">D プレミアム個別指導</th></tr>
               </thead>
               <tbody>
                  <tr>
                     <td>授業 / 月</td>
                     <td>月謝</td>
                  </tr>
                  <tr>
                     <td>週1日（各90分 × 4 / 月）</td>
                     <td>{d.l1}</td>
                  </tr>
                  <tr>
                     <td>週2日（各90分 × 8 / 月）</td>
                     <td>{d.l2}</td>
                  </tr>
                  <tr>
                     <td>週3日（各90分 × 12 / 月）</td>
                     <td>{d.l3}</td>
                  </tr>
                  <tr>
                     <td>週4日（各90分 × 16 / 月）</td>
                     <td>{d.l4}</td>
                  </tr>
               </tbody>
            </table>

            <p className="desc">
               ※小中学生は追加オプションを付けなくても学費に週1回のH.演習授業がついています。<br/>
               H.演習授業に関しては部活や習い事の関係で来れない場合は自宅での学習にすることが可能です。<br/>
               中学生はG.教科書対応の映像授業が追加料金なしで受講できます。<br/>
               小中学生はF.ビットキャンパスタッチは追加料金なしで受講できます。
            </p>
         </div >
         
         

      </>
   )
}



export default IndividData